<template>
  <div>
    <table class="table is-fullwidth" v-if="monthlyUsage?.length">
      <thead>
        <tr>
          <th>Year/Month</th>
          <th>Total Usage</th>
          <th>Satellite Usage</th>
          <th>Cellular Usage</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="usage in monthlyUsage" :key="usage.year+usage.month+usage.value">
          <td>{{ usage.year }}/{{ usage.month }}</td>
          <td>{{ $numeral(usage.value).format('0.00 b') }}</td>
          <td>{{ $numeral(usage.satelliteValue).format('0.00 b') }}</td>
          <td>{{ $numeral(usage.cellularValue).format('0.00 b') }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <p>No usage found for this subscription.</p>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useSubscriptions2Store } from '../subscriptions2-store';

const store = useSubscriptions2Store();
const monthlyUsage = computed(() => store.state.subscription?.monthlyUsageHistory);
</script>
